"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSleepTimeBeforeRetry = void 0;
var getSleepTimeBeforeRetry = function (_a) {
    var retry = _a.retry, _b = _a.retryCounter, retryCounter = _b === void 0 ? 1 : _b, _c = _a.retryTimeInterval, retryTimeInterval = _c === void 0 ? 1000 : _c, retryIntervalNonIncrement = _a.retryIntervalNonIncrement;
    if (!retry) {
        return 0;
    }
    if (retryIntervalNonIncrement) {
        return retryTimeInterval;
    }
    return retryCounter * retryTimeInterval;
};
exports.getSleepTimeBeforeRetry = getSleepTimeBeforeRetry;
